import { render } from "./PowerUpContainer.vue?vue&type=template&id=2f6c674c&scoped=true"
import script from "./PowerUpContainer.vue?vue&type=script&lang=js"
export * from "./PowerUpContainer.vue?vue&type=script&lang=js"

import "./PowerUpContainer.vue?vue&type=style&index=0&id=2f6c674c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f6c674c"]])

export default __exports__